export default "__VITE_ASSET__Bv_CrvjG__"